import { Text, Modal, Button } from '@rsos/base-components';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/base-components/Modal/ModalComponents';
import { useCurrentPSAPAccountID } from '@rsos/reduxDataStore/src/features/capstone/psapInfo';
import { conversationStateValues } from '@rsos/reduxDataStore/src/features/conversations/conversations.typings';
import useDisplayPhoneNumber from '../../../../hooks/useDisplayPhoneNumber';
import { getChatExitActionForCurrentUser } from './helpers';

interface EndChatModalProps {
  callerID: string | null;
  isLoading: boolean;
  isOpened: boolean;
  conversation: conversationStateValues | undefined;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Modal for ending a conversation
 */
const EndChatModal = ({
  callerID,
  isLoading,
  isOpened,
  conversation,
  onClose,
  onConfirm,
}: EndChatModalProps) => {
  const displayPhoneNumber = useDisplayPhoneNumber(callerID);
  const currentUserAuthorityId = useCurrentPSAPAccountID();
  const exitAction = getChatExitActionForCurrentUser(
    conversation,
    currentUserAuthorityId,
  );

  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={350}
      id="modal-end-conversation"
    >
      <ModalHeader onClose={onClose}>
        <Text size="xlarge" fontWeight="semibold" color="secondaryText" mb={15}>
          {exitAction === 'leave'
            ? 'Leave chat?'
            : `End chat with ${displayPhoneNumber}?`}
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text size="normal" color="secondaryText">
          {exitAction === 'leave'
            ? 'By leaving the chat you will no longer be a part of the text conversation. Other participants will be unaffected.'
            : 'No additional messages will be sent for this incident.'}
        </Text>
      </ModalBody>
      <ModalFooter flow={12} justify="center">
        <Button btnType="tertiary" grow onClick={onClose}>
          Cancel
        </Button>
        <Button
          btnType="warning_primary"
          onClick={onConfirm}
          grow
          isLoadingProp={isLoading}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EndChatModal;
